import {
  ADD_MESSAGE,
  ADD_MESSAGES,
  BUTTON_CLICKED,
  BUTTON_POSTBACK,
  BUTTON_URL_OPEN
} from '../../actions/chat-body/index';

const initialState = {
  messages: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_MESSAGE:
      if (action.message) {
        return addMessage(state, action.message);
      } else {
        return state;
      }
    case ADD_MESSAGES:
      return addMessages(state, action.messages);
    case BUTTON_CLICKED:
    case BUTTON_POSTBACK:
    case BUTTON_URL_OPEN:
    default:
      return state;
  }
}

function addMessage(state, message) {
  return {...state, messages: [...state.messages, message]};
}

function addMessages(state, messages) {
  return {...state, messages: state.messages.concat(messages)};
}



// WEBPACK FOOTER //
// ./src/reducers/chat-body/index.js